import Store from '@/store';
import PTC_Boletos from '@/api/PTC/PTC_Boletos.client';
import Notifier from '@/libs/Notifier';

export default class PTC_BoletosService {
  constructor() {
    this.client = new PTC_Boletos();
    this.store = Store;
    this.notify = new Notifier();
  }

  async retornaBoletos(query) {
    try {
      this.store.commit('PTC_BoletosClient/SET_IS_LOADING', true);

      if (!query) query = {};
      const pagination = this.store.getters['PTC_BoletosClient/getPagination'];

      if (!query.page) {
        query.page = pagination.currentPage;
      }

      if (!query.limit) {
        query.limit = pagination.perPage;
      }

      const data = await this.client.retornaBoletos(query);

      if (data && typeof data === 'object') {
        if (data.items && Array.isArray(data.items)) {
          this.store.commit('PTC_BoletosClient/SET_BOLETOS', data.items);

          this.store.commit('PTC_BoletosClient/SET_PAGINATION', {
            totalItems: data.totalRecords || 0,
            currentPage: parseInt(data.page || 1),
            perPage: parseInt(data.limit || pagination.perPage),
            totalPages: parseInt(data.totalPages || 0),
          });
        } else if (Array.isArray(data)) {
          this.store.commit('PTC_BoletosClient/SET_BOLETOS', data);

          this.store.commit('PTC_BoletosClient/SET_PAGINATION', {
            totalItems: pagination.totalItems,
            currentPage: parseInt(query.page || 1),
            perPage: parseInt(query.limit || pagination.perPage),
          });
        } else {
          this.store.commit('PTC_BoletosClient/SET_BOLETOS', []);
        }
      } else {
        this.store.commit('PTC_BoletosClient/SET_BOLETOS', []);
      }
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_BoletosClient/SET_IS_LOADING', false);
    }
  }
}
